module.exports = __webpack_public_path__ + "static/img/stamp_hands_black.002d42f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stamp/stamp_hands_black.png
// module id = nTY2
// module chunks = 44